var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEqual } from "lodash";
import { useDebounce as useDebounceBase } from "use-debounce";
export var useDebounce = function (value, delay, options) {
    if (delay === void 0) { delay = 550; }
    return useDebounceBase(value, delay, __assign({ equalityFn: isEqual }, options));
};
